export class Reason {
  id?: number | null;
  name?: string | null;
  code?: string | null;

  constructor(dto?: Partial<Reason>) {
    Object.assign(this, dto);
  }
}
